import { render, staticRenderFns } from "./rows.vue?vue&type=template&id=1db60e20&lang=pug"
import script from "./rows.vue?vue&type=script&lang=js"
export * from "./rows.vue?vue&type=script&lang=js"
import style0 from "./rows.vue?vue&type=style&index=0&id=1db60e20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports